<template>
  <div id="detail" class="mr-page">
    <img class="mr-banner-img" src="@/assets/serviceImg/ylsf1.png" alt="医疗送返" />

    <section class="mr-section">
      <div class="mr-section-title">服务介绍</div>
      <div class="mr-section-content">{{ pageCopy.intro }}</div>
    </section>

    <section class="mr-section">
      <div class="mr-section-title">核心服务</div>
      <div class="mr-section-content">{{ pageCopy.coreService }}</div>
    </section>

    <section class="mr-section">
      <div class="mr-section-title">所需材料</div>
      <div class="mr-section-content">{{ pageCopy.materials }}</div>
    </section>

    <section class="mr-section">
      <div class="mr-section-title">使用方式</div>
      <div class="mr-section-content">
        {{ pageCopy.usageBefore }}
        <a :href="hotlineTel" class="mr-hotline-link">{{ hotlineDisplay }}</a>
        {{ pageCopy.usageAfter }}
      </div>
    </section>

    <section v-if="serviceExtra.responseTime || serviceExtra.usageLimit" class="mr-section">
      <div class="mr-section-title">服务说明</div>
      <ul class="mr-extra-list">
        <!-- <li v-if="serviceExtra.responseTime">响应时效：{{ serviceExtra.responseTime }}</li> -->
        <li v-if="serviceExtra.usageLimit">权益次数：{{ serviceExtra.usageLimit }}</li>
      </ul>
    </section>

    <div class="mr-action-bar">
      <button
        type="button"
        class="mr-action-btn"
        :class="{ 'mr-action-btn--disabled': !equityCanUse }"
        :disabled="!equityCanUse"
        @click="actionCallHelp"
      >{{ getServiceBtnText }}</button>
    </div>

    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <span class="close" @click="showModal = false">&times;</span>
        <p class="modal-tip">该项权益需开通以下服务权益</p>
        <div class="modal-card" @click="equity">
          <img class="modal-card-bg" src="@/assets/img/qykbj.png" alt="" />
          <h3 class="modal-card-title">大救星-星健康权益卡</h3>
          <div class="modal-card-desc">多项健康权益尊享，为您健康守护</div>
          <div class="modal-card-btn">了解更多</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTaiheServiceCopy } from '@/utils/taiheServiceCopy'
import equityUsedCountMixin from '@/mixins/equityUsedCountMixin'

/** 24 小时救援热线 */
const RESCUE_HOTLINE_DISPLAY = '+ 86-10-89180868'
const RESCUE_HOTLINE_TEL = 'tel:+861089180868'

/** 医疗送返统一展示文案 */
const MEDICAL_RETURN_COPY = Object.freeze({
  intro:
    '保障人出行期间因意外或突发疾病住院，出院时经救援及主治医生共同确认有医疗必要，服务商将安排适当转运方式将其送回常住地医疗机构或家中。相关费用由服务商承担，最高不超过合同约定限额。',
  coreService:
    '全面掌握出院时医疗状况，评估医疗送返适应症、制定紧急医疗转运方案，床对床全流程协调安排',
  materials:
    '需提供门急诊就诊记录，入院记录，血液检查及放射科检查报告，个人身份证正反面，护照个人信息页/海关页，事故简单经过等。',
  usageBefore: '登录【大救星健康版】APP 一键救援，或拨打 24 小时热线 ',
  usageAfter:
    ' 提交需求；服务专员联系对应医疗机构获取书面医疗材料并提交到救援医生评估是否符合服务约定，1-2个工作日制定救援方案，实施救援。'
})

/**
 * 各 productId 响应时效与权益次数（949/947 单独配置，其余走 taiheServiceCopy 解析）
 * @type {Record<string, { responseTime: string, usageLimit: string }>}
 */
const MEDICAL_RETURN_EXTRA_BY_PRODUCT = Object.freeze({
  '949': {
    responseTime: '5分钟内',
    usageLimit: '不限次，限额20万元'
  },
  '947': {
    responseTime: '5分钟内响应',
    usageLimit: '以权益卡载明服务额度为限'
  }
})

/**
 * 从 legacy 文案中解析响应时效、权益次数
 * @param {string} legacyCopy
 * @returns {{ responseTime: string, usageLimit: string }}
 */
function parseMedicalReturnServiceExtra(legacyCopy) {
  const text = String(legacyCopy || '')
  const responseMatch = text.match(/响应时效：([^（）]+)/)
  const countMatch = text.match(/权益次数：([^（）]+)/)
  return {
    responseTime: responseMatch ? responseMatch[1].trim() : '',
    usageLimit: countMatch ? countMatch[1].trim() : ''
  }
}

export default {
  equityServiceKey: 'medicalReturn',
  mixins: [equityUsedCountMixin],
  data() {
    return {
      showModal: false,
      equityinfoType: false,
      hotlineDisplay: RESCUE_HOTLINE_DISPLAY,
      hotlineTel: RESCUE_HOTLINE_TEL
    }
  },
  computed: {
    /**
     * 页面主体文案（各 productId 统一展示）
     * @returns {{ intro: string, coreService: string, materials: string, usageBefore: string, usageAfter: string }}
     */
    pageCopy() {
      const productId = this.$route.query.productId
      if (productId === '949' || productId === 949) {
        return MEDICAL_RETURN_COPY
      }
      if (productId === '947' || productId === 947) {
        return MEDICAL_RETURN_COPY
      }
      getTaiheServiceCopy(productId, 'medicalReturn', MEDICAL_RETURN_COPY.intro)
      return MEDICAL_RETURN_COPY
    },
    /**
     * 根据 productId 返回响应时效与权益次数
     * @returns {{ responseTime: string, usageLimit: string }}
     */
    serviceExtra() {
      const productId = this.$route.query.productId
      const idStr = productId != null ? String(productId).trim() : ''
      if (idStr && MEDICAL_RETURN_EXTRA_BY_PRODUCT[idStr]) {
        return MEDICAL_RETURN_EXTRA_BY_PRODUCT[idStr]
      }
      const legacy = getTaiheServiceCopy(productId, 'medicalReturn', '')
      if (legacy) {
        const parsed = parseMedicalReturnServiceExtra(legacy)
        if (parsed.responseTime || parsed.usageLimit) {
          return parsed
        }
      }
      return {
        responseTime: '5分钟内响应',
        usageLimit: '不限次，以服务限额为限'
      }
    }
  },
  created() {
    this.equityinfoType = localStorage.getItem('equityinfo')
  },
  beforeCreate() {
    document.title = '医疗送返'
    document.querySelector('#app').setAttribute('style', 'background-color:#F2F3F5')
  },
  mounted() {
    if (localStorage.getItem('oldAge') == 1) {
      document.getElementById('html').style.fontSize = '48px'
    }
  },
  methods: {
    /**
     * 获取服务：校验权益与剩余次数后跳转一键救援
     */
    actionCallHelp() {
      if (this.equityinfoType == false || this.equityinfoType == 'false') {
        this.showModal = true
        return
      }
      this.goRescueWithCaseType()
    },
    /**
     * 跳转权益卡介绍
     */
    equity() {
      this.$router.push({
        path: '/equity',
        query: {}
      })
    }
  }
}
</script>

<style scoped lang="less">
.mr-page {
  min-height: 100vh;
  padding: 1rem 0.5rem calc(76px + env(safe-area-inset-bottom));
  background: #f2f3f5;
  box-sizing: border-box;
}

.mr-banner-img {
  width: 100%;
  display: block;
  margin-bottom: 12px;
}

.mr-section {
  margin-bottom: 12px;
  padding: 16px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
}

.mr-section-title {
  position: relative;
  padding-left: 10px;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 700;
  color: #333333;
  line-height: 1.3;
}

.mr-section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 3px;
  width: 4px;
  height: 16px;
  border-radius: 2px;
  background: linear-gradient(180deg, #00c275 0%, #4ecdc4 100%);
}

.mr-section-content {
  font-size: 14px;
  color: #666666;
  line-height: 1.75;
  text-align: justify;
}

.mr-hotline-link {
  color: #00bb82;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
}

.mr-hotline-link:active {
  opacity: 0.75;
}

.mr-extra-list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.mr-extra-list li {
  margin-bottom: 10px;
  font-size: 14px;
  color: #666666;
  line-height: 1.65;
}

.mr-extra-list li:last-child {
  margin-bottom: 0;
}

.mr-action-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  padding: 10px 16px calc(10px + env(safe-area-inset-bottom));
  background: rgba(242, 243, 245, 0.96);
  backdrop-filter: blur(8px);
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
}

.mr-action-btn {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 22px;
  background: rgb(0, 187, 130);
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.mr-action-btn:active {
  opacity: 0.9;
  transform: scale(0.99);
}

.mr-action-btn--disabled,
.mr-action-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.modal {
  position: fixed;
  z-index: 1000000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background-color: #fefefe;
  padding: 8% 5%;
  border-radius: 12px 12px 0 0;
  position: absolute;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
}

.modal-tip {
  margin: 0 0 20px;
  font-size: 15px;
  color: #333333;
  text-align: center;
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  line-height: 1;
}

.close:hover,
.close:focus {
  color: #000000;
  cursor: pointer;
}

.modal-card {
  position: relative;
  height: 160px;
  overflow: hidden;
  border-radius: 12px;
}

.modal-card-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.modal-card-title {
  position: absolute;
  top: 56px;
  left: 24px;
  margin: 0;
  font-size: 18px;
  color: #333333;
}

.modal-card-desc {
  position: absolute;
  top: 88px;
  left: 24px;
  font-size: 13px;
  color: #666666;
}

.modal-card-btn {
  position: absolute;
  top: 56px;
  right: 16px;
  width: 72px;
  height: 28px;
  border-radius: 16px;
  background: rgb(74, 71, 64);
  color: #f2d57a;
  font-size: 12px;
  line-height: 28px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/detailsH5/medicalReturn.vue